import { connect } from 'react-redux';
import AdvisorProfileAvatar from './advisor_profile_avatar';
import withPGTranslation from '../../config/withPGTranslation';

const mapStateToProps = ({
  advisors
}, { advisorId }) => ({
  ...(advisors || {})[parseInt(advisorId, 10)] || {}
});

export default connect(mapStateToProps, {})(withPGTranslation(AdvisorProfileAvatar));
